import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { callAPIWithoutAuth } from "../../utils/apiUtils";
import { apiUrls } from "../../utils/apiUrls";

export const fetchBrands = createAsyncThunk(
  'logos/fetchBrands',
  async (limit = 12, { rejectWithValue }) => {
    try {
      const params = {};
      if (limit != null) {
        params.limit = limit;
      }
      
      const response = await callAPIWithoutAuth(
        apiUrls.logoListing,
        params,
        "GET",
        {}
      );

      if (response?.data?.success) {
        const brands = response.data.data.data.map((item) => ({
          id: item.id,
          name: item.name,
          image: item.image,
          image_url: item.image_url,
          image_link: item.image_link,
          description: item.description,
          status: item.status
        }));
        return brands;
      } else {
        return rejectWithValue(response?.data?.message || 'Failed to fetch brands');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Network error');
    }
  }
);

const logoSlice = createSlice({
  name: 'logo',
  initialState: {
    brands: [],
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBrands.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBrands.fulfilled, (state, action) => {
        state.loading = false;
        state.brands = action.payload;
      })
      .addCase(fetchBrands.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch brands';
      });
  }
});

export default logoSlice.reducer;